import { debug, observer, pr, React, RouteComponentProps, ui } from "aaa";
import { pushRoute } from "stores/RouterFunctions";
import { ISigningResponse } from "types/signing";
import { CardShort } from "../common/Card";
import { SigningComponent } from "../signing/views/SigningComponent";
import { ActivateCardStore } from "./ActivateCardStore";

type IProps = RouteComponentProps<{}> & {
    store: ActivateCardStore;
};

@observer
export class ActivateCardSigning extends React.Component<IProps, {}> {
    render() {
        return (
            <SigningComponent
                signingInfo={this.props.store.response ? this.props.store.response.signInfo : undefined}
                content={
                    <div>
                        <pr.SigningLabelContainer>
                            <pr.SigningLabelTitle>{ui.__("signing.action.label")}</pr.SigningLabelTitle>
                            <pr.SigningLabel>{ui.__("activateCard.document.title")}</pr.SigningLabel>
                            <br />

                            <pr.SigningLabelTitle>{ui.__("loan.signing.product.title")}</pr.SigningLabelTitle>
                            <CardShort card={this.props.store.cardStore.card} showNumber />
                        </pr.SigningLabelContainer>
                    </div>
                }

                onSuccess={(response: ISigningResponse) => {
                    debug.log("### signing success", response);
                    pushRoute("success");
                }}
                onRetry={async () => await this.props.store.activateCard()}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/activateCard/ActivateCardSigning.tsx